import React from "react";
import { Form, Modal, Row } from "react-bootstrap";
import Fontstyling from "../../../../components/common/comman";
import { useState } from "react";
import { useRef } from "react";
import { useEffect } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import {
  GetLsrafDetails,
  AddLsraf,
  DeleteLsraf,
  UpdateLsraf,
} from "../../../../api/User/ACG/LSRAFApi";
import CustomButton from "../../../../components/common/CustomButton";
import DeleteModal from "../../../../components/common/Modal/DeleteModal";
import CustomMaterialTable from "../../../../components/common/CustomMaterialTable";
import toastFile from "../../../../Service/ToastFile";
import CustomInputField from "../../../../components/common/CustomInputField";
import Required from "../../../../components/Required";

const schema = Yup.object().shape({
  gender: Yup.string()
    .notOneOf(["Select Gender"], "Please select gender")
    .required("Please select gender"),
  age: Yup.number()
    .integer()
    .min(0, "Number must be positive")
    .typeError("Please enter a valid number")
    .required("Please enter age"),
  lifestyle_Risk: Yup.string()
    .notOneOf(["Select Risk"], "Please select risk")
    .required("Please select risk"),
  lsraf: Yup.number()
    .typeError("Please enter a valid number")
    .required("Please enter LSRAF"),
});

const LSRAF = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [witchAction, setWitchAction] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const buttonRef = useRef(null);

  const column = [
    {
      title: "Gender",
      field: "gender",
    },
    {
      title: "Age",
      field: "age",
    },
    {
      title: "Lifestyle Risk",
      field: "lifestyle_Risk",
    },
    {
      title: "LSRAF",
      field: "lsraf",
    },
  ];

  useEffect(() => {
    getLsrafDetailsData();
  }, []);

  const getLsrafDetailsData = () => {
    setIsLoading(true);
    GetLsrafDetails()
      .then((res) => {
        if (res.status === 200 || res.status === 204) {
          setData(res.data);
        }
      })
      .catch((err) => console.log({ err }))
      .finally((res) => setIsLoading(false));
  };
  const handleActions = (values) => {
    setShowModal(false);
    buttonRef.current.disabled = true;

    if (witchAction === "add") {
      const { gender, age, lifestyle_Risk, lsraf } = values;
      const payload = {
        id: 0,
        gender_Age: gender + "0",
        age: +age,
        lifestyle_Risk,
        gender,
        lsraf: +lsraf,
      };

      AddLsraf(payload).then((res) => {
        if (res.status === 200 || res.status === 204) {
          getLsrafDetailsData();
          toastFile("new");
          setShowModal(false);
          setSelectedRowData(null);
        }else if (res?.response?.status === 400) {
          toastFile(res?.response?.data,'error');
          setShowModal(false);
        }
      });
    } else if (witchAction === "update") {
      const { gender, age, lifestyle_Risk, lsraf } = values;
      const payload = {
        id: selectedRowData.id,
        gender_Age: gender + "0",
        age: +age,
        lifestyle_Risk,
        gender,
        lsraf: +lsraf,
      };

      UpdateLsraf(selectedRowData.id, payload).then((res) => {
        if (res.status === 200 || res.status === 204) {
          getLsrafDetailsData();
          toastFile("update");
          setShowModal(false);
          setSelectedRowData(null);
        }else if (res?.response?.status === 400) {
          toastFile(res?.response?.data,'error');
          setShowModal(false);
        }
      });
    }
  };

  return (
    <div>
      {showModal && <Modal
        show={showModal}
        aria-labelledby="contained-modal-title-vcenter"
        centered={witchAction !== 'delete'}
      >
        <Modal.Header
          closeButton
          onHide={() => {
            setShowModal(false);
            setSelectedRowData(null);
          }}
        >
          <Modal.Title
            id="contained-modal-title-vcenter"
            style={Fontstyling.modalHeading}
          >
            {witchAction === "add"
              ? "Add "
              : witchAction === "update"
                ? "Update "
                : "Delete "}
            LSRAF
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Formik
            validationSchema={schema}
            onSubmit={handleActions}
            initialValues={{
              gender: selectedRowData
                ? selectedRowData.gender
                : "Select Gender",
              age: selectedRowData ? selectedRowData.age : 0,
              lifestyle_Risk: selectedRowData
                ? selectedRowData.lifestyle_Risk
                : "Select Risk",
              lsraf: selectedRowData ? selectedRowData.lsraf : 0,
            }}
          >
            {({
              handleSubmit,
              handleChange,
              handleBlur,
              values,
              touched,
              errors,
            }) => (
              <Form onSubmit={handleSubmit}>
                {witchAction === "delete" ? (
                  <DeleteModal
                    onClickYes={() => {
                      DeleteLsraf(selectedRowData?.id).then((res) => {
                        if (res.status === 200 || res.status === 204) {
                          toastFile("delete");
                          setShowModal(false);
                          getLsrafDetailsData();
                          setSelectedRowData(null);
                        }
                      }).catch(err => console.log(err));
                    }}
                    onClickNo={() => setShowModal(false)}
                  />
                ) : (
                  <>
                    <Row className="mb-2 gap-3">
                      <Form.Group>
                        <Form.Label
                          className="text-nowrap"
                          style={Fontstyling.label}
                        >
                          Gender<Required />
                        </Form.Label>
                        <Form.Select
                          className="rounded-0"
                          style={Fontstyling.label}
                          name="gender"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          isInvalid={
                            values.gender === "Select Gender" && touched.gender
                          }
                        >
                          {["Select Gender", "F", "M"].map((item, index) => (
                            <option
                              value={item}
                              selected={values.gender === item}
                            >
                              {item}
                            </option>
                          ))}
                        </Form.Select>
                        <Form.Control.Feedback type="invalid">
                          {errors.gender}
                        </Form.Control.Feedback>
                      </Form.Group>
                      <CustomInputField
                        label="Age"
                        name="age"
                        maxLength={3}
                        value={values}
                        handleChange={handleChange}
                        handleBlur={handleBlur}
                        touched={touched}
                        errors={errors}
                        isRequired
                      />
                      <Form.Group>
                        <Form.Label
                          className="text-nowrap"
                          style={Fontstyling.label}
                        >
                          Lifestyle Risk<Required />
                        </Form.Label>
                        <Form.Select
                          className="rounded-0"
                          style={Fontstyling.label}
                          name="lifestyle_Risk"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          isInvalid={
                            values.lifestyle_Risk === "Select Risk" &&
                            touched.lifestyle_Risk
                          }
                        >
                          {[
                            "Select Risk",
                            "Very Low",
                            "Low",
                            "Moderate",
                            "High",
                            "Very High",
                          ].map((item, index) => (
                            <option
                              value={item}
                              selected={values.lifestyle_Risk === item}
                            >
                              {item}
                            </option>
                          ))}
                        </Form.Select>
                        <Form.Control.Feedback type="invalid">
                          {errors.lifestyle_Risk}
                        </Form.Control.Feedback>
                      </Form.Group>
                      <CustomInputField
                        label="LSRAF"
                        name="lsraf"
                        maxLength={10}
                        value={values}
                        handleChange={handleChange}
                        handleBlur={handleBlur}
                        touched={touched}
                        errors={errors}
                        isRequired
                      />
                    </Row>
                    <div className="d-flex align-items-center justify-content-end gap-3 my-4">
                      <button
                        ref={buttonRef}
                        style={Fontstyling.savebutton}
                        type="submit"
                      >
                        save
                      </button>
                      <button
                        style={Fontstyling.cancelbutton}
                        type="reset"
                        onClick={() => setShowModal(false)}
                      >
                        Cancel
                      </button>
                    </div>
                    <span className="text-success" style={{ fontSize: "12px" }}>
                      * No special characters are allowed
                    </span>
                  </>
                )}
              </Form>
            )}
          </Formik>
        </Modal.Body>
      </Modal>}
      <div className="text-end py-3 border-bottom">
        <CustomButton
          onClick={() => {
            setWitchAction("add");
            setShowModal(true);
          }}
        >
          Add LSRAF
        </CustomButton>
      </div>
      <CustomMaterialTable
        column={column}
        data={data}
        selectedRow={selectedRow}
        setSelectedRow={setSelectedRow}
        setWitchAction={setWitchAction}
        setSelectedRowData={setSelectedRowData}
        setShowModal={setShowModal}
        isLoading={isLoading}
      />
    </div>
  );
};

export default LSRAF;
